import { Component } from '@theme/component';

/**
 * A custom element that handles product-level quote requirements.
 * This runs on all product pages, regardless of whether variants exist.
 */
export default class ProductQuoteHandler extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    // Check for product-level quote requirement on page load
    this.#checkProductQuoteRequirement();
  }

  /**
   * Checks if the product requires a quote request at the product level.
   * This overrides variant-level quote requirements.
   */
  #checkProductQuoteRequirement() {
    const productRequestQuote = this.dataset.productRequestQuote;
    const requiresQuote = productRequestQuote === 'true';
    
    if (requiresQuote) {
      this.#updateProductQuoteFormDisplay(true);
    }
  }

  /**
   * Updates quote form display based on product-level requirements.
   * This is separate from variant-level logic.
   */
  #updateProductQuoteFormDisplay(/** @type {boolean} */ shouldShowQuote) {
    const quoteFormElements = document.querySelectorAll('[data-request-quote-form-display], [data-request-quote-form-active], [data-hide-price-on-quote]');
    
    quoteFormElements.forEach(element => {
      if (element instanceof HTMLElement) {
        if (element.hasAttribute('data-request-quote-form-display')) {
          element.setAttribute('data-request-quote-form-display', shouldShowQuote.toString());
        }
        if (element.hasAttribute('data-request-quote-form-active')) {
          element.setAttribute('data-request-quote-form-active', shouldShowQuote.toString());
        }
        if (element.hasAttribute('data-hide-price-on-quote')) {
          element.setAttribute('data-hide-price-on-quote', shouldShowQuote.toString());
        }
      }
    });
  }
}

if (!customElements.get('product-quote-handler')) {
  customElements.define('product-quote-handler', ProductQuoteHandler);
}
